import { Box, Typography } from '@mui/material';
import { useStore } from '@store/GlobalStore';
import { FallbackProps } from 'react-error-boundary';
import { shallow } from 'zustand/shallow';

export const FallbackQuoteDetails = ({ error }: FallbackProps) => {
  const { isInternalUser } = useStore((state) => state.userAuth, shallow);
  console.error(error);
  return (
    <Box
      sx={{
        position: 'fixed',
        top: 0,
        right: 0,
        bottom: 0,
        left: 0,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          marginBottom: '60px',
        }}
      >
        <Typography variant='h3' sx={{ marginBottom: '20px' }}>
          Something went wrong.
        </Typography>
        <Typography variant='body' sx={{ marginBottom: '5px' }}>
          There has been an issue loading the quote details.
        </Typography>
        {!isInternalUser && (
          <>
            <Typography variant='body' sx={{ marginBottom: '5px' }}>
              Please try again or contact LIO support at
            </Typography>
            <Typography variant='body' sx={{ marginBottom: '5px' }}>
              <a href='mailto:service@lioinsurance.com'>service@lioinsurance.com</a>, or call 877-546-7155 M-F
            </Typography>
            <Typography variant='body' sx={{ marginBottom: '5px' }}>
              between 8:30am - 8:00pm ET.
            </Typography>
          </>
        )}
      </Box>
    </Box>
  );
};
